// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTA-module--cta--1S-yu","button":"CTA-module--button--34sTB"};